export const getFeature = (featureName: API.Feature["feature"], features: ReadonlyArray<API.Feature>): API.Feature => {
    const feature = features?.find((f) => f.feature === featureName);
    return feature ?? { feature: featureName, max: 0 };
};
